import React from 'react';
import ContextMenu from 'relements/build/esm/overlays/contextMenu';

import More from './icons/More.svg';

import styles from './ListItem.scss';

const ListItem = (props) => {
  const {
    title,
    contextMenuOptions,
    lastContextMenuItem,
    handleOnClick,
    disabled,
    highlight,
    ref,
    id,
  } = props;

  const [highlightItem, setHightlightItem] = React.useState(false);

  React.useEffect(() => {
    highlight && setHightlightItem(true);
    setTimeout(() => {
      setHightlightItem(false);
    }, 2000);
  }, [highlight]);

  return (
    <div
      className={`${styles.ListItem} ${disabled && styles.ListItemDisabled} ${
        highlightItem && styles.ListItemHighlight
      }`}
      onClick={handleOnClick}
      ref={ref}
      id={id}
      data-testid="listItem"
    >
      {title}
      {contextMenuOptions && (
        <ContextMenu.Icon
          iconType={More}
          className={styles.ListItemContextMenu}
          prefixClassName="ListItemContextMenuContent"
          offset={{ top: lastContextMenuItem ? -90 : 32, left: -18 }}
        >
          {contextMenuOptions}
        </ContextMenu.Icon>
      )}
    </div>
  );
};

export default ListItem;
